<template>
    <div>
        <div>
            <span class="form-label">Occupancy Hazards</span>
        </div>
        <div class="occupancy-hazards">
            <el-collapse v-model="activeIndex">
                <el-collapse-item
                    v-for="(item, index) in buildingList"
                    :key="item.name"
                    :name="index"
                >
                    <template slot="title">
                        <span>{{ item.name }}</span>
                    </template>

                    <div class="mb-1" v-if="item.ohz.length">
                        <el-tag
                            v-for="(tag, index) in item.ohz"
                            :key="tag"
                            :closable="!readOnly"
                            @close="item.ohz.splice(index, 1)"
                            type="success"
                            effect="plain"
                            class="mr-5px"
                        >
                            {{ tag }}
                        </el-tag>
                    </div>
                    <div v-if="!readOnly">
                        <el-button
                            size="small"
                            type="primary"
                            icon="el-icon-edit"
                            @click="editClick(item)"
                            >{{ $t('Edit') }}</el-button
                        >
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>

        <el-dialog
            v-if="buildingModal"
            :title="buildingItem ? buildingItem.name : null"
            :visible.sync="buildingModal"
            append-to-body
            :close-on-click-modal="false"
        >
            <el-checkbox-group v-model="buildingItem.ohz" size="small" class="checkbox-grp">
                <el-row :gutter="10">
                    <el-col :span="6" v-for="item in ohzTypes" :key="item">
                        <div>
                            <el-checkbox :label="item" border></el-checkbox>
                        </div>
                    </el-col>
                </el-row>
            </el-checkbox-group>

            <div slot="footer" class="dialog-footer">
                <el-button class="el-button--primary" @click="save">{{ $t('Complete') }}</el-button>
                <el-button @click="cancel">{{ $t('Cancel') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Collection from '@/lib/data/Collection';
import BuildingRSA from '@/data/BuildingRSA';

export default {
    props: {
        value: {
            type: Array,
            default: new Collection({
                model: BuildingRSA,
            }),
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activeIndex: null,
            buildingList: null,
            buildingItem: null,
            buildingModal: false,
            ohzTypes: [
                'Agglomerators',
                'Ammonia Installation(s)',
                'Anechoic Chambers',
                'Battery Charging Areas',
                'Blast Furnaces',
                'Blow Moulding',
                'Boiling of Flammable Liquids',
                'Cable Landing Station',
                'CNC/DNC Machines',
                'Combustible Powder Operations',
                'Commercial Kitchen',
                'Industrial Conveyors',
                'Data Centre',
                'Exothermic Reactions Involving Flammable Liquids',
                'Extraction from Hazardous  Processes',
                'Flammable Liquid Operations',
                'Food Owens',
                'Fuel Fired Ovens, Furnaces and Kilns (metal and Minerals)',
                'Fuel Fired Space Heating Appliances',
                'Grain Milling',
                'Grain Storage',
                'Hazardous Metal',
                'High Pressure Hydraulic Systems',
                'Industrial Deep Fat Fryers',
                'Mainframe Computer/Server Rooms',
                'Molten Metals',
                'Oil Quenching',
                'Pan or Plate Fryers',
                'Plastic Dip Tanks',
                'Plastic Injection Moulding',
                'Plastic / Resin Coating',
                'Plastics Contact Moulding',
                'Plastics Extrusion',
                'Plating Lines',
                'Powder Coating',
                'Presses ( High Pressure)',
                'Printing Equipment',
                'PV-Cell Array Roof Mounted> 10kW',
                'Salt Bath(s)',
                'Sunas(s)',
                'Semiconductor Process Equipment',
                'Smokers',
                'Special Atmosphere Furnaces',
                'Spray Dryers',
                'Storage Vessels / Tank Areas (Gas)',
                'Storage Vessels / Tank Areas (Ignitable Liquids)',
                'Storage Vessels / Tank Areas (Non-Combustible Liquids)',
                'Telecomunications Rooms',
                'Thearmal Fluid System(s)',
                'Warehousing/Storage',
                'Wood Working',
                'Yankee Dryers',
                '(Factor Removed Biodisel Manufacture)',
                '(Factor Removed Black Liquor Recovery Boilers)',
                '(Factor Removed Earth Stations)',
                '(Factor Removed Exchange (Telecoms))',
                '(Factor Removed Sub-Sea Cabling)',
                '(Factor Removed Swimming Pool)',
                '(Factor Removed Wet Benches)',
            ],
        };
    },
    created() {
        this.buildingList = this.value;
        this.activeIndex = this.buildingList.map((item, index) => index);
    },
    methods: {
        editClick(data) {
            this.buildingItem = data;
            this.buildingModal = true;
        },
        save() {
            this.buildingModal = false;
            this.buildingItem.commit();
        },
        cancel() {
            this.buildingModal = false;
            this.buildingItem.reject();
        },
    },
};
</script>
<style lang="scss">
.checkbox-grp {
    .el-checkbox {
        height: 40px !important;
        width: 100% !important;
        &:last-of-type {
            margin-right: 0;
            margin-bottom: 5px !important;
        }
    }
}
</style>
